<template>
  <div class="flex px-40 py-8 bg-[#D8D8D8] justify-between" id="contact">
    <div class="w-1/2">
      <div class="flex items-center justify-start align-start">
        <div class="w-48 h-1 rounded-sm bg-[#696969]"></div>
        <h1 class="px-8 py-8 text-xl font-bold primary">Contact</h1>
      </div>
      <p class="text-5xl font-bold text-left text-black">
        <span class="primary">Contactez-</span> Nous & Nous Pourrons
      </p>
      <p class="py-4 text-5xl font-bold text-left text-black">
        Travailler Ensemble
      </p>
      <p class="text-base text-[#696969] text-left">
        Laissez-nous un message et nous vous répondrons dans les brefs et
        meilleurs délais
      </p>
      <form action="">
        <div class="flex flex-col pt-5">
          <input
            type="text"
            name="name"
            placeholder="Votre Nom"
            class="border-[1px] border-[#696969] border-solid rounded-lg py-4 px-4 mb-6"
          />
          <input
            type="email"
            name="email"
            placeholder="Votre Email"
            class="border-[1px] border-[#696969] border-solid rounded-lg py-4 px-4 mb-4"
          />
          <textarea
            name="description"
            cols="30"
            rows="10"
            placeholder="Votre message"
            class="border-[1px] border-[#696969] border-solid rounded-lg py-4 px-4 mb-4"
          ></textarea>
          <button
            type="submit"
            class="px-10 py-3 my-3 font-medium text-center text-white rounded-lg bg-primary focus:ring-4 focus:outline-none text-md"
          >
            Envoyer
          </button>
        </div>
      </form>
    </div>
    <div class="flex object-cover">
      <img src="../../../assets/contact.png" alt="" srcset="" />
    </div>
  </div>
</template>
